const common = {
  message: {
    failureMessageUpload: 'Une erreur est survenue, veuillez réessayer'
  }
};

export default common;
